import { useQuery } from '@tanstack/react-query';

import getBulkOrderings from '../api/getBulkOrderings';

const useBulkOrderings = (productId: string) => {
  return useQuery({
    queryKey: ['bulk-orderings', productId],
    queryFn: () => getBulkOrderings(productId),
    enabled: !!productId,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: true
  });
};

export default useBulkOrderings;
